module.exports = __webpack_public_path__ + "static/img/visa-logo.404e9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/visa-logo.png
// module id = 908
// module chunks = 1